import { render, staticRenderFns } from "./OriginVue.vue?vue&type=template&id=09aca57d&"
import script from "./OriginVue.vue?vue&type=script&lang=js&"
export * from "./OriginVue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports